export default __webpack_public_path__ + "static/media/AcessosIconFinish.b58ea1ba.svg";